<template>
  <div class="people_mng pd2430">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="学员管理" name="student">
        <section class="el-tab-pane-section">
          <!-- 表单 -->
          <el-form
            :model="studentQueryParams"
            ref="studentQueryForm"
            :inline="true"
            label-width="100px"
          >
            <el-form-item label="姓名：" prop="truename">
              <el-input
                v-model="studentQueryParams.truename"
                placeholder="请输入"
                clearable
                size="small"
              />
            </el-form-item>

            <el-form-item label="手机号：" prop="tel">
              <el-input
                v-model="studentQueryParams.tel"
                placeholder="请输入"
                clearable
                size="small"
              />
            </el-form-item>

            <el-form-item label="班委：" prop="committee">
              <el-select
                v-model="studentQueryParams.committee"
                placeholder="请选择班委"
                clearable
                filterable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in committeeOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>

                <el-option label="全部" value=""></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="省市区：" prop="areaTreeId">
              <el-cascader
                v-model="studentQueryParams.areaTreeId"
                :options="areaTreesArr"
                clearable
                @change="handlerCascader"
              ></el-cascader>
            </el-form-item>

            <el-form-item label="单位：" prop="unit">
              <el-select
                v-model="studentQueryParams.unit"
                placeholder="请选择单位"
                clearable
                filterable
                remote
                :remote-method="remoteMethod"
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in unitOptions"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="性别：" prop="sexy">
              <el-select
                v-model="studentQueryParams.sexy"
                placeholder="请选择性别"
                clearable
                filterable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in sexyOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleStudentQuery">查询</el-button>
              <el-button @click="resetStudentQuery">重置</el-button>
            </el-form-item>
          </el-form>
          <!-- 6按钮 -->
          <el-row class="mb8 operation">
            <el-col :span="1.5" class="mr10">
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="mini"
                @click="handleSelectionUser(1)"
              >
                添加已有用户
              </el-button>
            </el-col>
            <el-col :span="1.5" class="mr10">
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="mini"
                @click="handleAdd(1)"
              >
                添加新学员
              </el-button>
            </el-col>
            <el-col :span="1.5" class="mr10">
              <el-button type="primary" size="mini" @click="handleUpload">
                批量导入
              </el-button>
            </el-col>
            <el-col :span="1.5" class="mr10">
              <el-button type="primary" size="mini" @click="handleSetGroup">
                小组设置
              </el-button>
            </el-col>
            <el-col :span="1.5" class="mr10">
              <el-button type="primary" size="mini" @click="handleQrcode">
                班级报名二维码
              </el-button>
            </el-col>
            <el-col :span="1.5" class="mr10">
              <el-button type="primary" size="mini" @click="handleExcelExport">
                导出
              </el-button>
            </el-col>
            <el-col :span="1.5" class="mr10" v-if="import_id">
              <el-button type="warning" @click="onImportStudentDetail" size="mini">
                导入学员详情
              </el-button>
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            :data="studentPostList"
            @sort-change="sortChange"
            style="margin: 24px 0; width: 100%"
            :header-cell-style="{
              background: '#F0F0F0',
              fontSize: '14px',
              height: '50px',
              fontWeight: 500,
              color: '#333',
            }"
          >
            <el-table-column label="ID" width="100" align="center" prop="id" />
            <el-table-column
              label="姓名"
              align="left"
              prop="truename"
              sortable="custom"
              :sort-orders="['ascending', 'descending', null]"
            />
            <el-table-column label="性别" align="center" prop="sexy_name" />
            <el-table-column label="手机号" width="120" align="center" prop="tel" />
            <el-table-column
              label="单位"
              align="center"
              width="150"
              prop="unit_name"
              sortable="custom"
              show-overflow-tooltip
              :sort-orders="['ascending', 'descending', null]"
            />
            <el-table-column
              label="地区"
              align="center"
              prop="province_name"
              sortable="custom"
              width="160"
            >
              <template slot-scope="scope">
                {{ scope.row.province_name }} {{ scope.row.city_name }}
                {{ scope.row.area_name }}
              </template>
            </el-table-column>

            <el-table-column
              label="隶属小组"
              align="center"
              prop="group_title"
              sortable="custom"
              width="160"
              :sort-orders="['ascending', 'descending', null]"
            />
            <el-table-column label="班委" align="center" prop="committee" />
            <el-table-column
              label="入班时间"
              align="center"
              prop="create_time"
              width="160"
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.create_time, "{y}-{m}-{d} {h}:{i}") }}
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              width="400"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleDetails(scope.row, 1)">
                  查看详情
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleStudentUpdate(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleStudentDelete(scope.row)"
                >
                  移出班级
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleStudentMoveClass(scope.row)"
                >
                  调班
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleStudentMoveGroup(scope.row)"
                >
                  调组
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleStudentLeader(scope.row)"
                >
                  班委
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleStudentReplace(scope.row)"
                >
                  替换
                </el-button>
                <el-button size="mini" type="text" @click="resetPassword(scope.row)">
                  重置密码
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :total="total"
            :selectSize="[10, 20, 30, 40]"
            @changePage="changePage"
            @changeSize="changeSize"
            v-if="total !== 0"
          ></Pagination>
          <!-- 添加已有用户 -->
          <AddUserDialog
            ref="childAddUser"
            @requestCommonFn="requestCommonFn"
          ></AddUserDialog>
          <!-- 查看学员详情 -->
          <!-- <StudentDetaillDialog ref="childStudentDetail"></StudentDetaillDialog> -->
          <!-- 添加新学员 -->
          <AddNewStudentDialog
            ref="childAddNewStudent"
            @requestCommonFn="requestCommonFn"
          ></AddNewStudentDialog>
          <!-- 移出班级 -->
          <RemoveClass
            ref="childRemoveClass"
            @requestCommonFn="requestCommonFn"
          ></RemoveClass>
          <!-- 调班 -->
          <ChangeClassDialog
            ref="childChangeClass"
            @requestCommonFn="requestCommonFn"
          ></ChangeClassDialog>
          <!-- 调组 -->
          <ChangeGroupDialog
            ref="childChangeGroup"
            @requestCommonFn="requestCommonFn"
            :class_id="+class_id"
          ></ChangeGroupDialog>
          <!-- 班委设置 -->
          <StudentReplace ref="childStudentReplace" @requestCommonFn="requestCommonFn">
          </StudentReplace>
          <!-- 替换学员 -->
          <CommitteeDialog
            ref="childCommitteeDialog"
            @requestCommonFn="requestCommonFn"
          ></CommitteeDialog>
          <!-- 批量导入学员 -->
          <BatchImportStudent
            ref="childBatchImportStudent"
            @requestCommonFn="requestCommonFn"
            @changeImportID="changeImportID"
          ></BatchImportStudent>
          <!-- 报名二维码 -->
          <SignUpCodeDialog
            ref="childSignUpCode"
            @requestCommonFn="requestCommonFn"
            :class_id="+class_id"
          ></SignUpCodeDialog>
          <!-- 导入学员详情 -->
          <ImportStudentDetail
            ref="ipStuDetailRef"
            @requestCommonFn="requestCommonFn"
          ></ImportStudentDetail>
        </section>
      </el-tab-pane>
      <el-tab-pane label="班主任管理" name="teacher">
        <section class="el-tab-pane-section">
          <!-- 搜索 -->
          <MySearch
            :showLabel1="4"
            :triggerPhName="5"
            :showIpt2="1"
            :showSelect1="0"
            :show2="0"
            :show3="0"
            ref="childSearch1"
            @changeVal="changeVal"
            @resetPage="resetPage"
            @requestCommonFn="requestCommonFn"
          ></MySearch>
          <el-table
            :data="tearcherPostList"
            :header-cell-style="{
              background: '#F0F0F0',
              fontSize: '14px',
              height: '50px',
              fontWeight: 500,
              color: '#333',
            }"
            style="margin: 0 0 24px"
          >
            <el-table-column label="ID" align="center" prop="id" />
            <el-table-column label="姓名" align="center">
              <template slot-scope="scope">
                {{ scope.row.truename }}
                <span class="public-label-1 ml6" v-if="scope.row.is_teacher == 1">
                  主班
                </span>
                <span class="public-label-1 ml6" v-if="scope.row.is_teacher == 2">
                  副班
                </span>
              </template>
            </el-table-column>
            <el-table-column label="手机号" align="center" prop="tel" />
            <el-table-column label="入班时间" align="center" prop="create_time" />

            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              width="180"
            >
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleDetails(scope.row, 2)">
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :total="total"
            :selectSize="[10, 20, 30, 40]"
            @changePage="changePage"
            @changeSize="changeSize"
            v-if="total !== 0"
          ></Pagination>
        </section>
      </el-tab-pane>
      <el-tab-pane label="专家管理" name="expert">
        <section class="el-tab-pane-section">
          <!-- 搜索 -->
          <MySearch
            :showLabel1="4"
            :triggerPhName="5"
            :showIpt2="1"
            :showSelect1="0"
            :show2="0"
            :show3="0"
            ref="childSearch"
            @changeVal="changeVal"
            @resetPage="resetPage"
            @requestCommonFn="requestCommonFn"
          ></MySearch>
          <p class="pb24">
            提示：本班级专家来源于本班级日程管理处选择的专家，另外如果某位专家信息有误，请联系专家库管理人员进行修改，此处无编辑权限。
          </p>
          <el-table
            :data="tearcherPostList"
            :header-cell-style="{
              background: '#F0F0F0',
              fontSize: '14px',
              height: '50px',
              fontWeight: 500,
              color: '#333',
            }"
            style="margin: 0 0 24px"
          >
            <el-table-column
              label="ID"
              align="center"
              prop="expert_id"
              show-overflow-tooltip
            />
            <el-table-column label="姓名" align="center" prop="username" />
            <el-table-column label="手机号" align="center" prop="phone">
            </el-table-column>
            <el-table-column label="省/市" align="center">
              <template slot-scope="{ row }">
                <div>
                  {{ row.work_province_id ? row.work_province_id : "—" }}/{{
                    row.work_city_id ? row.work_city_id : "—"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="学段/学科" align="center">
              <template slot-scope="{ row }">
                <div>
                  {{ row.can_stages ? row.can_stages : "—" }}/{{
                    row.now_subjects ? row.now_subjects : "—"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="110px"
              label="评价问题数量"
              align="center"
              prop="subject_num"
            />
            <el-table-column label="平台满意度" align="center" prop="project_whole" />
            <el-table-column label="本班满意度" align="center" prop="whole" />

            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              width="120"
            >
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="handleDetails(scope.row, 3)">
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :total="total"
            :selectSize="[10, 20, 30, 40]"
            @changePage="changePage"
            @changeSize="changeSize"
            v-if="total !== 0"
          ></Pagination>
          <!-- 查看专家详情 -->
          <ExpertDetailDialog ref="childExpertDetail"></ExpertDetailDialog>
        </section>
      </el-tab-pane>
    </el-tabs>
    <!-- 查看班主任详情 -->
    <StudentDetaillDialog ref="childStudentDetail"></StudentDetaillDialog>
  </div>
</template>

<script>
import {
  GetAreaTrees,
  GetUnitList,
  GetStaffList,
  GetDataList,
  StudentListExcel,
  getTearcherList,
  getExpertList,
  postApiStudentResetPassword,
} from "@/api/tearcher";
import StudentReplace from "@/components/dialog/studentReplace/index.vue";
export default {
  components: {
    StudentReplace,
  },
  data() {
    return {
      activeName: "student",
      studentQueryParams: {
        areaTreeId: [],
      },
      committeeOptions: [
        { label: "班长", value: "monitor" },
        { label: "副班", value: "vice_monitor" },
        { label: "生活委员", value: "life_monitor" },
        { label: "学习委员", value: "study_monitor" },
        { label: "组长", value: "group_leader" },
      ],
      unitOptions: [], // 单位
      areaTreesArr: [],
      studentPostList: [], // 表格列表
      titleOptions: [], // 获取职称列表
      levelOptions: [], // 获取学段列表
      educationOptions: [], // 获取学历列表
      tearcherPostList: [], // 班主任列表
      sexyOptions: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      class_id: "",
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      order: "", //
      province_id: "", //
      city_id: "", //
      area_id: "", //
      real_name: "", //
      phoneNum: "", //
      unitSearch: "",
      import_id: "",
    };
  },
  methods: {
    changeImportID(id) {
      this.import_id = id;
    },
    onImportStudentDetail() {
      this.$refs.ipStuDetailRef.operationDialog(this.class_id);
    },
    // 重置页数
    resetPage() {
      this.currentPage = 1;
    },
    // 修改查询的值
    changeVal(val) {
      this.real_name = val.workName;
      this.phoneNum = val.modelVal;
    },
    //批量导入
    handleUpload() {
      this.$refs.childBatchImportStudent.operationDialog(this.class_id);
    },

    //排序
    sortChange: function (column, prop, order) {
      let paramsOrder = undefined;
      switch (column.prop) {
        case "truename":
          if (column.order === "descending") {
            paramsOrder = "convert(u.truename-using-gbk)-desc";
          } else if (column.order === "ascending") {
            paramsOrder = "convert(u.truename-using-gbk)-asc";
          }

          break;
        case "unit_name":
          if (column.order === "descending") {
            paramsOrder = "u.unit-desc";
          } else if (column.order === "ascending") {
            paramsOrder = "u.unit-asc";
          }
          break;
        case "province_name":
          if (column.order === "descending") {
            paramsOrder = "u.province_id-desc,u.city_id-desc,u.city_id-desc";
          } else if (column.order === "ascending") {
            paramsOrder = "u.province_id-asc,u.city_id-asc,u.city_id-asc";
          }
          break;
        case "group_title":
          if (column.order === "descending") {
            paramsOrder = "bcg.id-desc";
          } else if (column.order === "ascending") {
            paramsOrder = "bcg.id-asc";
          }
          break;
        default:
          paramsOrder = undefined;
      }

      this.order = paramsOrder;
      this.requestCommonFn();
    },

    // 查看详情
    handleDetails(row, type) {
      if (type == 3) {
        // 专家详情
        this.$refs.childExpertDetail.operationDialog(row, this.class_id);
      } else if (type == 2) {
        // 班主任详情
        this.$refs.childStudentDetail.operationDialog(row.user_id, type);
      } else {
        // 学员详情
        this.$refs.childStudentDetail.operationDialog(row.id, type);
      }

      this.$nextTick(function () {});
    },
    // 编辑
    handleStudentUpdate(row) {
      let title = "编辑学员";
      // this.$nextTick(function () {
      this.$refs.childAddNewStudent.operationDialog(
        this.educationOptions,
        this.unitOptions,
        this.titleOptions,
        this.levelOptions,
        this.class_id,
        row.id,
        row.user_id,
        title
      );
    },
    // 移出班级
    handleStudentDelete(row) {
      //   this.removeStudent = row;
      this.$nextTick(function () {
        this.$refs.childRemoveClass.operationDialog(row.id);
      });
    },
    // 调班
    handleStudentMoveClass(row) {
      //   this.moveClass = row;
      this.$nextTick(function () {
        this.$refs.childChangeClass.operationDialog(row.id);
      });
    },
    //调组
    handleStudentMoveGroup(row) {
      this.$nextTick(function () {
        this.$refs.childChangeGroup.operationDialog(row.id, row.group_id);
      });
    },
    // 班委
    handleStudentLeader(row) {
      this.$nextTick(function () {
        this.$refs.childCommitteeDialog.operationDialog(row, this.class_id);
      });
    },
    // 替换
    handleStudentReplace(e) {
      const type = 1;
      this.$nextTick(() => {
        this.$refs.childStudentReplace.operationDialog({
          areaTreesArr: this.areaTreesArr,
          titleOptions: this.titleOptions,
          unitOptions: this.unitOptions,
          levelOptions: this.levelOptions,
          type,
          class_id: this.class_id,
          educationOptions: this.educationOptions,
          user_id: e.id,
        });
      });
    },
    // 选择地址
    handlerCascader(val) {},

    //获取学员列表
    requestCommonFn() {
      if (this.activeName === "student") {
        let length = this.studentQueryParams.areaTreeId.length;
        let province_id = "";
        let city_id = "";
        let area_id = "";
        if (length > 0) {
          province_id = this.studentQueryParams.areaTreeId[0];
          city_id = this.studentQueryParams.areaTreeId[1];
          area_id = this.studentQueryParams.areaTreeId[2];
        }
        GetStaffList({
          page: this.currentPage,
          limit: this.pageSize,
          class_id: this.class_id,
          truename: this.studentQueryParams.truename,
          order: this.order,
          tel: this.studentQueryParams.tel,
          sexy: this.studentQueryParams.sexy,
          unit: this.studentQueryParams.unit,
          committee: this.studentQueryParams.committee,
          province_id: province_id,
          city_id: city_id,
          area_id: area_id,
        }).then((res) => {
          this.studentPostList = res.data.list;
          this.total = res.data.total;
        });
      } else if (this.activeName === "teacher") {
        getTearcherList({
          page: this.currentPage,
          limit: this.pageSize,
          class_id: this.class_id,
          truename: this.real_name,
          tel: this.phoneNum,
          role: 7,
        }).then((res) => {
          this.tearcherPostList = res.data.list;
          this.total = res.data.total;
        });
      } else {
        // 专家列表
        getExpertList({
          page: this.currentPage,
          limit: this.pageSize,
          class_id: this.class_id,
          truename: this.real_name,
          tel: this.phoneNum,
        }).then((res) => {
          this.tearcherPostList = res.data.list;
          this.total = res.data.total;
        });
      }
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 导出
    handleExcelExport() {
      // 处理省市区
      let length = this.studentQueryParams.areaTreeId.length;
      let province_id = "";
      let city_id = "";
      let area_id = "";

      if (length > 0) {
        province_id = this.studentQueryParams.areaTreeId[0];
        city_id = this.studentQueryParams.areaTreeId[1];
        area_id = this.studentQueryParams.areaTreeId[2];
      }
      StudentListExcel({
        page: this.currentPage,
        limit: this.pageSize,
        class_id: this.class_id,
        truename: this.studentQueryParams.truename,
        order: this.order,
        tel: this.studentQueryParams.tel,
        sexy: this.studentQueryParams.sexy,
        unit: this.studentQueryParams.unit,
        committee: this.studentQueryParams.committee,
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }).then((res) => {
        saveAs(res, "学生列表.xls");
      });
    },
    // 打开二维码
    handleQrcode() {
      this.$refs.childSignUpCode.operationDialog();
    },
    // 小组设置
    handleSetGroup() {
      this.$refs.childChangeGroup.handleCreateGroup();
    },
    // 添加新学员
    handleAdd(type) {
      let title = "添加新学员";
      this.$nextTick(function () {
        this.$refs.childAddNewStudent.operationDialog(
          this.educationOptions,
          this.unitOptions,
          this.titleOptions,
          this.levelOptions,
          this.class_id,
          "",
          "",
          title
        );
      });
    },
    // 添加已有用户
    handleSelectionUser(type) {
      this.$nextTick(function () {
        this.$refs.childAddUser.operationDialog(
          this.areaTreesArr,
          this.titleOptions,
          this.unitOptions,
          this.levelOptions,
          type,
          this.class_id
        );
      });
    },

    /** 学生搜索按钮操作 */
    handleStudentQuery() {
      this.currentPage = 1;
      this.requestCommonFn();
    },

    /** 学生重置按钮操作 */
    resetStudentQuery() {
      this.resetForm("studentQueryForm");
      this.order = "";
      this.requestCommonFn();
    },
    // 点击tabs
    handleClick(tab, event) {
      // 页数条数重置
      this.currentPage = 1;
      this.pageSize = 10;
      // 搜索重置
      this.real_name = "";
      this.phoneNum = "";
      this.$refs.childSearch.resetIptVal();
      this.$refs.childSearch1.resetIptVal();
      // 表单重置
      this.studentQueryParams = {};
      this.studentQueryParams.areaTreeId = [];
      this.resetForm("studentQueryForm");
      // 接口
      this.requestCommonFn();
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }

      this.requestCommonFn();
      //   console.log("切换班级");
    },
    // 单位搜索
    remoteMethod(value) {
      this.unitSearch = value;
      this.getUnitListFn();
    },
    getUnitListFn() {
      GetUnitList({ search: this.unitSearch }).then((res) => {
        this.unitOptions = res.data;
      });
    },
    // // 获取学科列表
    // getsubjectListFn(id) {
    //   GetDataList({ type: 5, id: id }).then((response) => {
    //     this.courseOptions = response.data;
    //   });
    // },
    resetPassword(e) {
      this.$confirm("您确定要重置密码吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          postApiStudentResetPassword({
            user_id: e.user_id,
            class_id: this.class_id,
          }).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          });
        })
        .catch(() => {});
    },
  },
  created() {
    // 获取地区树
    GetAreaTrees().then((res) => {
      this.areaTreesArr = res.data;
    });
    // 获取全部单位
    this.getUnitListFn();
    // 获取学历列表
    GetDataList({ type: 2 }).then((res) => {
      this.educationOptions = res.data;
    });
    // 获取职称列表
    GetDataList({ type: 3 }).then((res) => {
      this.titleOptions = res.data;
    });
    // 获取学段列表
    GetDataList({ type: 4 }).then((res) => {
      this.levelOptions = res.data;
    });
    this.createFn();
  },
};
</script>

<style lang="less" scoped>
.people_mng {
  .el-tabs {
    .el-tab-pane-section {
      /deep/ .el-form {
        .el-form-item {
          .el-input__inner {
            width: 198px;
            height: 32px;
          }
          .el-button {
            padding: 7px 20px;
          }
        }
      }
      .operation {
        .el-col {
          .el-button {
            margin-right: 10px;
          }
        }
      }
    }
  }
}
/deep/.my_search {
  .el-form-item {
    margin-left: 0;
    margin-right: 50px;
    &:nth-of-type(2) {
      margin-right: 0;
    }
  }
}
</style>
